import React, { useEffect } from 'react';
import Filters from '../../components/Filters';
import { Form } from 'react-bootstrap';
import MultiSelectField from '../../components/form/MultiSelectField';
import { faInfoCircle, faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const FiltersPartial = (props) => {
  const { filtersModel, setFiltersModel } = props;

  const onStatusAdded = (selectedItems, selectedOption) => {
    setFiltersModel((prevState) => {
      return { ...prevState, statuses: [...(prevState?.statuses || []), selectedOption.id] }
    })
  }

  const onStatusRemove = (selectedItems, removedOption) => {
    setFiltersModel((prevState) => {
      return { ...prevState, statuses: prevState.statuses.filter((id) => id !== removedOption.id) }
    })
  }

  const onOwnerTypeAdded = (selectedItems, selectedOption) => {
      setFiltersModel((prevState) => {
          return { ...prevState, owner_type: selectedOption.id }
      })
  }

  return <Filters filtersModel={filtersModel} setFiltersModel={setFiltersModel}>
    <div>
      <Form.Group className="mb-3">
        <Form.Label>Status</Form.Label>
        <MultiSelectField
          options={[
            {"id": "requested", "name": "Requested" },
            {"id": "assigned", "name": "Assigned" },
            {"id": "active", "name": "Active" },
            {"id": "blocked", "name": "Blocked" },
            {"id": "defective", "name": "Defective" },
            {"id": "deleted_by_sap", "name": "Deleted by SAP" }
          ]}
          fieldName="statuses"
          stateModel={filtersModel}
          labelAttr="name"
          valueAttr="id"
          displayValue="name"
          onSelect={onStatusAdded}
          onRemove={onStatusRemove}
          placeholder={"Select Status"}
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Owner Type</Form.Label>
        <MultiSelectField
          options={[
            {"id": "ServiceCenter", "name": "Service Center" },
            {"id": "CsWareHouse", "name": "Ware House" },
            {"id": "User", "name": "User" }
          ]}
          fieldName="owner_type"
          stateModel={filtersModel}
          labelAttr="name"
          valueAttr="id"
          displayValue="name"
          onSelect={onOwnerTypeAdded}
          singleSelect={true}
          placeholder={"Select Owner Type"}
        />
      </Form.Group>
    </div>
  </Filters>
};

export default FiltersPartial;

